import { delay } from './utilities'

const API = window.callpixels

// TODO: this whole file is basically pointless, it's just a thin wrapper around legacy functions
// either replaces functions with new ones or just calls them directly
const LegacyAPI = {
    loader() {
        LegacyAPI.showLoader()
        $(document).on('page:always', LegacyAPI.hideLoader)
        // @ts-ignore
        jQuery(window).load(LegacyAPI.hideLoader)
        delay(5000, LegacyAPI.hideLoader) // Fallback
    },

    showLoader() {
        API.utils.showLoading()
    },

    hideLoader() {
        API.utils.hideLoading()
    },

    // See flash_notice.js
    flashNotice(message: string, level: string, clear?: boolean) {
        return window.flashNotice(message, level, clear)
    },
}

export default LegacyAPI
window.LegacyAPI = LegacyAPI
